import styled from 'styled-components/native'

const FULL_HEIGHT = '100%'

export const Img = styled.Image.attrs(() => ({
  height: FULL_HEIGHT,
}))`
  height: ${props => props.height};
`
